import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

/**
 * Hebrew day letters for date formatting
 * Maps day numbers (0-6) to translation keys
 */
const DAY_LETTER_KEYS = {
  0: "common.days.sundayLetter",
  1: "common.days.mondayLetter",
  2: "common.days.tuesdayLetter",
  3: "common.days.wednesdayLetter",
  4: "common.days.thursdayLetter",
  5: "common.days.fridayLetter",
  6: "common.days.saturdayLetter"
};

const formatShortDateWithDay = (dateStr, t) => {
  if (!dateStr) return '';
  const date = moment.utc(dateStr);
  const dayLetter = t(DAY_LETTER_KEYS[date.day()]);
  return `${dayLetter} ${date.format('DD/MM')}`;
};

/**
 * MobileSummaryBar - Mobile sticky top bar showing trip details
 * Shows destination, dates with day of week - NOT price (price is in modal)
 *
 * @param {Object} props
 * @param {string} props.destination - Destination city name
 * @param {string} props.departureDate - Departure date string
 * @param {string} props.returnDate - Return date string
 * @param {number} props.nights - Number of nights
 * @param {Function} props.onOpenDetails - Handler for opening details modal
 * @param {Function} props.onBackToDeal - Handler for back to deal page
 */
const MobileSummaryBar = ({
  destination,
  departureDate,
  returnDate,
  nights,
  onOpenDetails,
  onBackToDeal
}) => {
  const { t } = useTranslation();

  return (
    <div className="mobile-summary-bar">
      <div className="mobile-summary-content">
        {/* Back button on the right */}
        {onBackToDeal && (
          <button
            className="mobile-summary-back-btn"
            onClick={onBackToDeal}
            aria-label={t('reservation.wizard.mobileSummaryBar.backToDeal')}
          >
            <ArrowForwardIcon />
          </button>
        )}

        <div className="mobile-summary-info">
          {destination && (
            <div className="mobile-summary-destination">
              {destination}
            </div>
          )}
          {departureDate && returnDate && (
            <div className="mobile-summary-dates">
              {formatShortDateWithDay(departureDate, t)} - {formatShortDateWithDay(returnDate, t)}
              {nights && <span className="mobile-summary-nights"> | {t('reservation.wizard.bookingDetails.nightsLabel', { count: nights })}</span>}
            </div>
          )}
        </div>

        <button
          className="mobile-summary-details-btn"
          onClick={onOpenDetails}
          aria-label={t('reservation.wizard.mobileSummaryBar.showDetails')}
        >
          {t('reservation.wizard.mobileSummaryBar.fullDetails')}
        </button>
      </div>
    </div>
  );
};

export default MobileSummaryBar;
